(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atp-artwork"]) return;
  try {
    

if (!customElements.get('atp-artwork')) {
  customElements.define('atp-artwork', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      this.addEventListener('click', (event) => {
        const request = event.target.closest('[data-atp-inquire]');
        if (request) {
          const inquiry = this.querySelector('.atp-art__inquiry');
          if (inquiry) {
            inquiry.open = true;
            const message = inquiry.querySelector('textarea');
            if (message && !message.value.trim()) message.value = request.dataset.atpInquire;
            message?.focus({preventScroll:true});
          }
        }
        const link = event.target.closest('[data-atp-zoom]');
        if (link && dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          dialog.querySelector('img').src = link.href;
          dialog.querySelector('img').alt = link.querySelector('img')?.alt || '';
          dialog.showModal();
        }
        if (event.target.closest('[data-atp-close]')) dialog?.close();
        if (event.target === dialog) dialog.close();
      });
      const success = this.querySelector('[data-atp-result]');
      if (success) { const details = success.closest('details'); details.open = true; success.focus(); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atp-partnerships"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atp-partnerships')) {
  customElements.define('atp-partnerships', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const select = this.querySelector('[data-part-select]');
      const sync = () => {
        const type = select?.selectedOptions[0]?.dataset.type || '';
        this.querySelectorAll('[data-part-fields]').forEach(group => {
          const active = group.dataset.partFields.split(' ').includes(type);
          group.hidden = !active;
          group.querySelectorAll('input,select,textarea').forEach(field => field.disabled = !active);
        });
      };
      select?.addEventListener('change', sync);
      this.querySelectorAll('[data-part-type]').forEach(link => link.addEventListener('click', () => {
        if (!select) return;
        const option = [...select.options].find(item => item.dataset.type === link.dataset.partType);
        if (option) select.value = option.value;
        sync();
        select.focus({preventScroll:true});
      }));
      sync();
      this.querySelector('[data-part-result]')?.focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
